import { useSelector } from 'react-redux';
import { useGetAgencyQuery, useEditAgencyMutation } from '../api';

// Returns the specified Agency's data and exposes methods for editing and creating an Agency
const useAgency = ({ id } = {}) => {
  const { agencyId: sessionAgencyId } = useSelector(({ user }) => user);

  const agencyId = id ?? sessionAgencyId;

  const {
    data: agency,
    isLoading,
    isError,
    error,
  } = useGetAgencyQuery(
    { id: agencyId },
    {
      skip: !agencyId,
    }
  );

  // Invalidates Agency cache upon edit
  const [edit, editAgencyResponse] = useEditAgencyMutation();

  return {
    agency,
    isLoading,
    isError,
    error,
    editAgencyResponse,
    edit,
  };
};

export default useAgency;
